<template>
  <div>
    <top-nav />
    <section id="content">
      <plan-builder />
    </section>
  </div>
</template>

<script>
import TopNav from './components/TopNav';
import PlanBuilder from './components/PlanBuilder';

export default {
  name: 'App',
  components: {
    PlanBuilder,
    TopNav
  },
  data() {
    return {};
  }
};
</script>
